import { useEffect, useState } from "react";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import {createClient} from '../../client/Client';

interface Process {
  key: string,
  status: {
    active: boolean;
    busy: boolean;
  }
}

interface ProcessSeries {
  name: string;
  y: number;
}

function LiveDataChart({url}) {
  
  let [data, setData] = useState({
    chart: {
      type: 'pie'
    },
    title: 'Loading',
    series: [{name: 'Loading', colorByPoint: false, data: []}]
  });
  
  
  useEffect(() => {
    const RestClient = createClient(url);

    RestClient.get('/status/threads').then(resp => {
      console.log("response:",resp);
      const seriesData = resp.data.reduce((arr: Array<ProcessSeries>, process: Process) => {
        console.log("Reducing:", arr);
        let series = arr.find(item => item.name === process.key);
        if(series) {
          series.y++;
        } else {
          arr.push({name: process.key, y: 1})
        }
        return arr;
      }, [])

      console.log("series", seriesData);
      const chartData = {
        title: 'Active Processes',
        chart: {
          type: 'pie'
        },
        series: [{
          name: 'Processes',
          colorByPoint: true,
          data: seriesData
        }]
      }

      
      setData(chartData);
      console.log("set chart data", chartData)
    });
  }, []);
  
 
  
  return(<div>
    {/* <button onClick={test}>Test</button> */}
    <HighchartsReact
      highcharts={Highcharts}
      options={data}
      />
  </div>)
}

export default LiveDataChart;